import { FormGroup, Col, Form, FormLabel } from 'react-bootstrap'
import { Controller } from 'react-hook-form'
import Select from 'react-select'

//
import LabelErrors from '../LabelErrors'
import { COLORS } from '../../../assets/styles/styles'
import { useState } from 'react'

// Custom option rendering
const CustomOption = (props) => {
  const [isHovered, setIsHovered] = useState(false)
  const { data, innerRef, innerProps, selectProps } = props

  return (
    <div
      ref={innerRef}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...innerProps}
      style={{
        margin: 1,
        height: 35,
        cursor: 'pointer',
        backgroundColor: isHovered ? COLORS.gray : 'white',
      }}
      // className={`d-flex align-items-center hover:tw-bg-select_item ${
      //   innerProps['aria-selected'] && 'tw-bg-active_g tw-text-white'
      // } tw-transition-colors tw-duration-200 pointer`}

      className={`d-flex align-items-center ${
        innerProps['aria-selected'] && 'bg-success text-white'
      } text-secondary p-2`}
    >
      {selectProps?.showImage && (
        <img
          src={data.image}
          alt={data.label}
          style={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            marginRight: 10,
          }}
        />
      )}
      {data.label}
    </div>
  )
}

// Custom single value rendering (selected item)
const CustomSingleValue = (props) => {
  const { data } = props
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img
        src={data.image}
        alt={data.label}
        style={{ width: 20, height: 20, marginRight: 8 }}
      />
      {data.label}
    </div>
  )
}

const ReactSelect = ({
  label = '',
  required = false,
  name = '',
  defaultValue = undefined,
  isCustom = false,
  showImage = false,
  options = [
    {
      label: 'One',
      value: '1',
    },
    {
      label: 'Two',
      value: '2',
    },
    {
      label: 'Three',
      value: '3',
    },
  ],
  control = {},
  isDisabled = false,
  placeholder = '',
  errorMessage = '',
  noGrid = false,
  onHandleChange = undefined,
  showError = true,
  colClass = '',
  formGroupClass = '',
  width = 'auto',
  xxl = '6',
  xl = '6',
  lg = '6',
  md = '6',
  sm = '12',
  xs = '12',
}) => {
  const renderInput = () => (
    <>
      {label && (
        <FormLabel style={{ color: COLORS.theme }} for={name}>
          {label} {required && <span className='text-danger'>*</span>}
        </FormLabel>
      )}
      <Controller
        name={name}
        defaultValue={defaultValue}
        render={({ field }) => (
          <Select
            {...field}
            isClearable={false}
            placeholder={placeholder || 'Select'}
            isDisabled={isDisabled}
            aria-label='Default select example'
            classNamePrefix='select'
            options={options}
            isSearchable={false}
            showImage={showImage}
            components={{
              // ...(isCustom && { Option: CustomOption }),
              Option: CustomOption,
              // SingleValue: CustomSingleValue,
              IndicatorSeparator: () => null,
              // DropdownIndicator: () => null,
              // Input: (props) => <Input {...props} isNumber={isNumber} />,
            }}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                boxShadow: state.isFocused
                  ? '0 0 0 .25rem rgba(13,110,253,.25)'
                  : baseStyles.boxShadow,
                '&:hover': {
                  // borderColor: COLORS.theme,
                  borderWidth: 1,
                },
                borderColor: state.isFocused
                  ? COLORS.theme
                  : baseStyles.borderColor,
                borderWidth: 1,
                borderRadius: 'var(--bs-border-radius)',
                width,
              }),
              placeholder: (baseStyles) => ({
                ...baseStyles,
                textOverflow: 'ellipsis',
                textWrap: 'nowrap',
                overflow: 'hidden',
              }),
              option: (baseStyles, state) => ({
                ...baseStyles,
                // backgroundColor: state.isSelected ? COLORS.theme : baseStyles.backgroundColor,
                // color: 'white',
                // '&:active': {
                //   backgroundColor: COLORS.theme + '90',
                // },
                // '&:hover': {
                //   backgroundColor: COLORS.theme + '99',
                // },
                borderTop: '1px solid white',
                borderRight: '1px solid white',
                borderLeft: '1px solid white',
              }),
              // indicatorsContainer: (baseStyles) => ({
              //   ...baseStyles,
              //   // height: 10,
              //   // width: 10,
              //   // display: 'none',
              // })
            }}
            {...(onHandleChange && {
              onChange: (value) => {
                field.onChange(value)
                onHandleChange(value)
              },
            })}
          />
        )}
        control={control}
      />
      {showError && <LabelErrors name={name} errorMessage={errorMessage} />}
    </>
  )

  return (
    <>
      {noGrid ? (
        <FormGroup className={formGroupClass}>{renderInput()}</FormGroup>
      ) : (
        <Col
          className={colClass}
          xs={xs}
          sm={sm}
          md={md}
          lg={lg}
          xl={xl}
          xxl={xxl}
        >
          <FormGroup className={formGroupClass}>{renderInput()}</FormGroup>
        </Col>
      )}
    </>
  )
}

export default ReactSelect
